function PermissionsHelper(permissions) {
	this.permissions = permissions;

	this.hasCreateAccountPermissions = () => {
		const ffgPermission = this.permissions.find((permission) =>
			permission.roles.includes('FFG')
		);
		if (ffgPermission) {
			return true;
		}
		return false;
	};

	this.hasCreateOrganizationPermissions = () => {
		const provisionerPermission = this.permissions.find((permission) =>
			permission.roles.includes('PROVISIONER')
		);
		if (provisionerPermission) {
			return true;
		}
		return false;
	};

	this.hasActionTriggerPermissions = () => {
		return this.hasCreateAccountPermissions();
	};

	this.hasCreateLearningPlanPermissions = () => {
		return this.hasCreateAccountPermissions();
	};

	this.hasCreateUserPermissions = () => {
		return true;
	};

	this.hasShowUsersPermissions = () => {
		const hasRequiredRole = this.permissions.some((permission) =>
			[
				'FFG',
				'PROVISIONER',
				'ORG_OWNER',
				'ORG_MANAGER',
				'PROCTOR'
			].some((role) => permission.roles.includes(role))
		);
		return hasRequiredRole;
	};

	this.hasShowReportsPermissions = () => {
		const hasRequiredRole = this.permissions.some((permission) =>
			[
				'FFG',
				'PROVISIONER',
				'ORG_OWNER',
				'ORG_MANAGER'
			].some((role) => permission.roles.includes(role))
		);
		return hasRequiredRole;
	};

	this.isOnlyProctor = () => {
		// console.log('checking proctor status');
		// console.log('permissions', this.permissions);

		// Check if the user has only the role "PROCTOR" and no other roles
		const onlyProctor =
			this.permissions.length === 1 &&
			this.permissions[0].roles.includes('PROCTOR');
		return onlyProctor;
	};
}

export default PermissionsHelper;
